import React, { useEffect, useState } from 'react'
import '../style/blog.css'
import { CircularProgress, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { searchBlogs } from '../services/BlogService';
import EmptyComponent from './messages/EmptyComponent';
import BlogCarousel from './BlogCarousel';
  

export default function Search() {

    const [searchResults, setSearchResults] = useState([])
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true)

    useEffect(()=>{
        setIsLoading(true)
        searchBlogs(location.state.searchKey)
        .then((res)=>{
            console.log(res.data)
            setSearchResults(res.data)
            setIsLoading(false)
        })
        .catch((err)=>{
            console.log(err)
            setIsLoading(false)
        })
    },[location.state.searchKey])

  return (
    <>
        <div className='search-results'>
                <div className='search-heading'>
                    <Typography sx={{variant:"body1", color:"text.primary", fontSize:45, }} >
                    Search Results:
                    </Typography>
                </div>
                {isLoading && <CircularProgress />}
                <div>
                {
                !isLoading &&
                searchResults != 0 ? 
                    <BlogCarousel blogs={searchResults} authorDetailsNeeded={true}/>
                : 
                    !isLoading &&
                    <EmptyComponent message="No Blogs found!"/>
                }
            </div>
        </div>
    </>
  )
}
